import type { CollectionEventDependencies } from './CollectionEventController';
import { openCollectionEventPopup } from './model/openCollectionEventPopup';
import { fillTokensRequirementsForRewards, getCurrentEventInstance } from './model/collectionEventUtils';

export function getCollectionEventDebugFunctions(
  dependencies: CollectionEventDependencies,
): Record<string, () => void> {
  const { observable } = dependencies;

  return {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'Clear event': (): void => {
      const { collectionEvent } = observable.getValue();
      observable.updateValue({
        collectionEvent: {
          ...collectionEvent,
          currentEvent: null,
        },
      });
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'Open popup': (): void => {
      void openCollectionEventPopup(dependencies);
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'Add 100 tokens': (): void => {
      const { collectionEvent } = observable.getValue();
      const eventInstance = getCurrentEventInstance(dependencies);

      if (!eventInstance) return;

      eventInstance.tokensCollected += 100;
      fillTokensRequirementsForRewards(dependencies, eventInstance);

      observable.updateValue({
        collectionEvent: {
          ...collectionEvent,
          currentEvent: eventInstance,
        },
      });
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'Add 1000 tokens': (): void => {
      const { collectionEvent } = observable.getValue();
      const eventInstance = getCurrentEventInstance(dependencies);

      if (!eventInstance) return;

      eventInstance.tokensCollected += 1000;
      fillTokensRequirementsForRewards(dependencies, eventInstance);

      observable.updateValue({
        collectionEvent: {
          ...collectionEvent,
          currentEvent: eventInstance,
        },
      });
    },
  };
}
